import { Component, OnInit } from "@angular/core";
import { DomSanitizer, SafeResourceUrl } from "@angular/platform-browser";
import { Router, ActivatedRoute } from "@angular/router";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { ApiHelper } from "./../../_helpers/api.helper";
import { CommonHelper } from "./../../_helpers/common.helper";
import { AppConfig } from "./../../../app/app.config";
import { ConstantHelper } from "./../../_helpers/constant.helper";
import { ArrayHelper } from "./../../_helpers/array.helper";
import { SweetAlertHelper } from "src/app/_helpers/sweet.alert.helper";
import { Message } from "src/app/_locale/message";
import Swal from "sweetalert2";
import { DataService } from "src/app/_helpers/data.service.helper";

@Component({
  selector: "app-doctor-profile",
  templateUrl: "./doctor-profile.component.html",
  styleUrls: ["./doctor-profile.component.scss"],
  providers: [AppConfig, CommonHelper],
})
export class DoctorProfileComponent implements OnInit {
  loggedInUserId: string;
  httpHeaders = new HttpHeaders({
    "Content-Type": "application/json",
  });
  httpOptions = {
    headers: this.httpHeaders,
  };
  profileObj: any = {};
  doctorObj: any = {};
  firstQues: any = [];
  secondQues: any = [];
  childRoute: string;
  que01SelectDisabledOption = true;
  que02SelectDisabledOption = true;
  statesArre = ArrayHelper.STATE_ARRAY;
  showLoader = false;
  message = Message;
  is_docs_signed: any;
  is_profile_edited: any;
  reviewProfile: boolean = true;
  changeSecQue: boolean = false;
  changePass: boolean = false;
  resignDocs: boolean = false;
  activeTab: string = 'profile';

  constructor(
    public commonHelper: CommonHelper,
    private appConfig: AppConfig,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private http: HttpClient,
    public sweetAlertHelper: SweetAlertHelper,
    private sanitizer: DomSanitizer,
    private dataService: DataService,
  ) {
    localStorage.setItem("childRoute", activatedRoute.snapshot.url[0].path);
    this.childRoute = activatedRoute.snapshot.url[0].path;
  }

  ngOnInit() {
    this.doctorObj.PhysicianSecondaryState = "";
    this.loggedInUserId =
      this.activatedRoute.snapshot.paramMap.get("loggedInUserId");
    this.findUserDetails(this.loggedInUserId);
    this.getDemographicPhysicianDetails(this.loggedInUserId);
    this.findDoctorByUserId(this.loggedInUserId);
    this.findFirstSecurityQues();
    this.findSecondSecurityQues();
    
  }

  findFirstSecurityQues() {
    const finalDataS = {
      company_slug: ConstantHelper.COMPANY_SLUG,
      setId: 1,
    };
    this.showLoader = true;
    this.http
      .post(
        this.appConfig.getLambdaUrl01() + ApiHelper.name_getAllQuestionsListApi,
        finalDataS,
        this.httpOptions
      )
      .subscribe(
        (apiResponse: any) => {
          this.que01SelectDisabledOption = false;
          this.firstQues = apiResponse.commandResult.data.questionsList;
          this.showLoader = false;
        },
        (err) => {
          // console.log(err);
        }
      );
  }

  findSecondSecurityQues() {
    const finalDataS = {
      company_slug: ConstantHelper.COMPANY_SLUG,
      setId: 2,
    };
    this.showLoader = true;
    this.http
      .post(
        this.appConfig.getLambdaUrl01() + ApiHelper.name_getAllQuestionsListApi,
        finalDataS,
        this.httpOptions
      )
      .subscribe(
        (apiResponse: any) => {
          this.que02SelectDisabledOption = false;
          this.secondQues = apiResponse.commandResult.data.questionsList;
          this.showLoader = false;
        },
        (err) => {
          // console.log(err);
        }
      );
  }

  findUserDetails(userId) {
    const finalData = {
      company_slug: ConstantHelper.COMPANY_SLUG,
      id: userId,
    };
    this.showLoader = true;
    return this.http
      .post(
        this.appConfig.getLambdaUrl03() + ApiHelper.name_getUserDetailApi,
        finalData,
        this.httpOptions
      )
      .subscribe(
        (apiResponse: any) => {
          if (apiResponse.commandResult.status === 1) {
            this.profileObj = apiResponse.commandResult.data.userInfo;
            this.showLoader = false;
          }
        },
        (err) => {
          // console.log(err);
        }
      );
  }

  findDoctorByUserId(userId) {
    const finalData = {
      userId,
    };
    this.showLoader = true;
    return this.http
      .post(
        this.appConfig.getLambdaUrl03() + ApiHelper.name_findDoctorByUserIdApi,
        finalData,
        this.httpOptions
      )
      .subscribe(
        (apiResponse: any) => {
          // console.log(apiResponse);
          if (apiResponse.commandResult.status === 1) {
            this.doctorObj = apiResponse.commandResult.data.npiInfo;
            if (this.doctorObj.siteUrl == "undefined") {
              this.doctorObj.siteUrl = "";
            }
            if (this.doctorObj) this.showLoader = false;
          }
        },
        (err) => {
          // console.log(err);
        }
      );
  }

  getDemographicPhysicianDetails(userId) {
    const finalData = {
      userId: userId,
    };
    this.showLoader = true;
    return this.http
      .post(
        this.appConfig.getLambdaUrl06() + ApiHelper.getDemographicPhysicianDetails,
        finalData,
        this.httpOptions
      )
      .subscribe(
        (apiResponse: any) => {
          if (apiResponse.commandResult.status === 1) {
            this.profileObj = apiResponse.commandResult.data.physicianInfo;
            this.is_profile_edited=apiResponse.commandResult.data.physicianInfo.is_profile_edited;
            this.is_docs_signed=apiResponse.commandResult.data.physicianInfo.is_docs_signed;
            this.dataService.setData(this.profileObj);
            this.showLoader = false;
          }
        },
        (err) => {
          // console.log(err);
        }
      );
  }

  async onReset() {
    // if (
    //   confirm(
    //     "PLEASE CONFIRM: Are you certain you want to return to the Home Page?"
    //   )
    // )
    // const alertStatus = await this.sweetAlertHelper.confirmPopUp(
    //   this.message.confirmTitle,
    //   this.message.confirmMessages.demographicsFormComp.onReset
    // );
    // if (alertStatus) {
      this.router.navigate([
        "/" + this.childRoute + "/dashboard/" + this.loggedInUserId,
      ]);
    // }
  }

  onSubmit(f) {
    if (!f.dirty) {
        if (this.is_profile_edited) {
          this.openAHSSignPage();
        }
        else
        {
      Swal.fire({
        title: "No Change",
        text: "Your profile has not been updated",
        showCancelButton: true,
        confirmButtonText: "OK",
        cancelButtonText: "Cancel",
      }).then((result) => {
        if (result.value) {
          this.router.navigate([
            "/" + this.childRoute + "/dashboard/" + this.loggedInUserId,
          ]);
        }
      });
    }
    } else {
      Swal.fire({
        title: "PLEASE CONFIRM",
        text: "Are you sure you want to make these changes?",
        showCancelButton: true,
        confirmButtonText: "OK",
        cancelButtonText: "Cancel",
      }).then((result) => {
        if (result.value) {
          const finalData = {
            company_slug: ConstantHelper.COMPANY_SLUG,
            userId: this.profileObj.RecordId,
            fullName: this.profileObj.FullName,
            mobile: this.profileObj.Mobile,
            ans_01: this.profileObj.Ans_01,
            ans_02: this.profileObj.Ans_02,
            queId_01: this.profileObj.QueId_01,
            queId_02: this.profileObj.QueId_02,
            email: this.profileObj.Email,
            npiId: this.doctorObj.Id,
            officeState: this.doctorObj.PhysicianState,
            officeCity: this.doctorObj.PhysicianCity,
            officeAddress: this.doctorObj.PhysicianOfficeAddress,
            streeAddOne: this.doctorObj.PhysicianStreet01,
            streeAddTwo: this.doctorObj.PhysicianStreet02,
            siteUrl: this.doctorObj.siteUrl,
            practiceName: this.doctorObj.PracticeName,
            zipCode: this.doctorObj.PhysicianZipCode,
            officePhone: this.doctorObj.PhysicianOfficePhone,
            degree: this.doctorObj.PhysicianDegree,
            npiNo: this.doctorObj.PhysicianNPI,
            speciality: this.doctorObj.PhysicianSpecialty,
            subSpeciality: this.doctorObj.PhysicianSubSpecialty,
            primaryState: this.doctorObj.PhysicianPrimaryState,
            primaryStateLicense: this.doctorObj.PhysicianPrimaryStateLicense,
            secondryState: this.doctorObj.PhysicianSecondaryState,
            secondryStateLicense: this.doctorObj.PhysicianSecondaryStateLicense,
          };
          this.dataService.setData(finalData);
          this.showLoader = true;
          return this.http
            .post(
              this.appConfig.getLambdaUrl06() + ApiHelper.updateDoctorProfile,
              finalData,
              this.httpOptions
            )
            .subscribe(
              async (apiResponse: any) => {
                // alert("Profile updated successfully.");
                this.showLoader = false;
                const alertStatus = await this.sweetAlertHelper.alertPopUp(
                  this.message.alertMessages.doctorProfileComp.onSubmit1
                ); 
                if(alertStatus){
                  const alertStatus1 = await this.sweetAlertHelper.confirmPopUp(
                    this.message.confirmTitle,
                    this.message.confirmMessages.demographicsSign.msgSign
                  );
                  if(alertStatus1){
                    this.openAHSSignPage();
                  }
                  else{
                    this.router.navigate([
                      "/" + this.childRoute + "/dashboard/" + this.loggedInUserId,
                    ]);  
                  }
                }
              },
              (err) => {
                // console.log(err);
              }
            );
          }
          });
        }
  }


  async openAHSSignPage() {
    this.activeTab = 'sign';
    this.router.navigate([
      "/" + this.childRoute + "/hipaa/" + this.loggedInUserId,
    ]);
  }

  // async openSignedDocs() {
  //   this.router.navigate(["/" + this.childRoute + "/review-signed-docs/" + this.loggedInUserId,]);
  // }

  goToContacChangePassword() {
    this.changePass = true;
    this.changeSecQue = false;
    this.reviewProfile = false;
    this.resignDocs = false;
    this.activeTab = 'password';

    return
    this.router.navigate([
      '/' + this.childRoute + '/change-password/' + this.loggedInUserId,
    ]);
  }

  goToContacChangeSecurityQuestions() {
    this.changeSecQue = true;
    this.changePass = false;
    this.reviewProfile = false;
    this.resignDocs = false;
    this.activeTab = 'security';
    return
    this.router.navigate([
      '/' + this.childRoute + '/security-question/' + this.loggedInUserId,
    ]);
  }

  openSignedDocs() {
    this.changeSecQue = false;
    this.resignDocs = true;
    this.changePass = false;
    this.reviewProfile = false;
    this.activeTab = 'review';

    return
    this.router.navigate(["/" + this.childRoute + "/review-signed-docs/" + this.loggedInUserId,]);
  }
  goToreviewProfile() {
    this.changePass = false;
    this.changeSecQue = false;
    this.reviewProfile = true;
    this.resignDocs = false;
    this.activeTab = 'profile';
    return
    this.router.navigate([
      '/' + this.childRoute + '/doctor-profile/' + this.loggedInUserId,
    ]);
  }

}
